import React, { FunctionComponent } from 'react';

import withIconContainer from './withIconContainer';

const IconSepa: FunctionComponent = () => (
    <svg fill="none" height="24" viewBox="0 0 35 24" width="35" xmlns="http://www.w3.org/2000/svg">
        <rect fill="#9A1B27" height="23" rx="3.5" stroke="#D9D9D9" width="34" x="0.5" y="0.5" />
        <path
            d="M10.758 11.652a5.095 5.095 0 00-1.29-.28 2.764 2.764 0 01-.747-.15.272.272 0 01-.165-.258.316.316 0 01.13-.252.703.703 0 01.43-.107.875.875 0 01.502.143.574.574 0 01.215.316l1.65-.165a2.03 2.03 0 00-.43-.71 1.564 1.564 0 00-.646-.388c-.394-.098-.8-.139-1.205-.122a3.809 3.809 0 00-1.227.158c-.28.092-.529.26-.717.488a1.205 1.205 0 00-.266.782c0 .265.089.523.252.732.15.207.357.366.595.459.412.133.834.231 1.262.294.255.035.505.098.746.186a.323.323 0 01.163.45.336.336 0 01-.112.124.861.861 0 01-.546.144.89.89 0 01-.516-.13.86.86 0 01-.294-.444l-1.736.165c.085.413.33.777.681 1.011a3.3 3.3 0 001.78.359c.473.02.946-.052 1.391-.215.307-.12.57-.33.753-.603.152-.227.234-.494.237-.767 0-.258-.08-.508-.23-.718a1.435 1.435 0 00-.645-.502h-.014zm10.638 1.241a.632.632 0 01-.509.258.724.724 0 01-.574-.265 1.205 1.205 0 01-.23-.803c-.03-.304.047-.608.216-.861a.703.703 0 01.856-.186c.09.046.167.112.227.193.161.238.237.524.215.81.03.302-.04.605-.2.861m.035-3.228c-.295 0-.586.074-.846.215-.241.15-.45.345-.617.574v-.688h-1.636v6.549h1.765v-2.417c.166.175.366.314.588.408.235.095.486.14.74.137a1.778 1.778 0 001.376-.603 2.51 2.51 0 00.538-1.736 2.912 2.912 0 00-.502-1.736 1.628 1.628 0 00-1.406-.703zm5.854 2.79c.006.184-.03.366-.108.531a.86.86 0 01-.359.352c-.163.094-.349.144-.538.143a.603.603 0 01-.43-.136.453.453 0 01.007-.66 1.73 1.73 0 01.674-.28c.259-.067.51-.143.754-.23v.28zm1.743 1.421a2.45 2.45 0 01-.043-.502v-2.016a1.995 1.995 0 00-.13-.681 1.292 1.292 0 00-.35-.545 1.614 1.614 0 00-.79-.373 7.187 7.187 0 00-1.262-.087 5.308 5.308 0 00-.904.072 2.13 2.13 0 00-.66.208c-.203.103-.38.25-.517.43-.136.212-.229.449-.272.696l1.671.18a.753.753 0 01.266-.41c.198-.104.421-.15.645-.135a.667.667 0 01.466.129c.104.126.153.289.137.452a5.901 5.901 0 01-.617.215c-.196.048-.622.139-1.277.272-.415.05-.806.225-1.12.502-.207.235-.318.54-.307.854a1.205 1.205 0 00.423.933c.35.275.79.41 1.233.38.368.008.733-.055 1.077-.187a2.26 2.26 0 00.681-.473 2 2 0 00.064.287c.035.094.078.186.13.272h1.635a2.275 2.275 0 01-.18-.473zM11.892 7.979v8.178l5.99 1.062V6.925l-5.99 1.054zm9.024 7.948a.316.316 0 00.064.216.18.18 0 00.137.071.172.172 0 00.143-.071c.04-.06.057-.13.05-.201a.345.345 0 00-.057-.216.18.18 0 00-.22-.055.172.172 0 00-.06.048.337.337 0 00-.057.216v-.008zm.394.366V16.2a.23.23 0 01-.208.115.314.314 0 01-.273-.186.465.465 0 01-.035-.202c0-.066.012-.132.036-.193a.286.286 0 01.385-.161.244.244 0 01.088.075v-.359h.122v1.004h-.115z"
            fill="#FEFEFE"
        />
        <mask
            height="33"
            id="mask0_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask0_1854_5393)">
            <path
                d="M21.755 16.3h.15v-.739h-.143l-.007.74zm0-.875h.15v-.143h-.143l-.007.143z"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask1_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask1_1854_5393)">
            <path
                d="M22.207 16.3v-.739h.115v.115a.3.3 0 01.072-.107.136.136 0 01.086-.022.245.245 0 01.122.043l-.044.115a.179.179 0 00-.086-.029.114.114 0 00-.071.022.136.136 0 00-.05.072.488.488 0 00-.022.143v.38l-.122.007z"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask2_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask2_1854_5393)">
            <path
                d="M22.91 15.863h.409a.25.25 0 00-.05-.144.187.187 0 00-.144-.071.195.195 0 00-.143.057.23.23 0 00-.072.158zm.409.193l.122.022a.308.308 0 01-.108.172.38.38 0 01-.466-.036.387.387 0 01-.093-.28.402.402 0 01.1-.286.323.323 0 01.244-.1.31.31 0 01.237.1c.068.08.101.182.093.287v.028h-.545c.002.066.028.13.072.18a.2.2 0 00.143.071.186.186 0 00.122-.043c.035-.03.06-.07.072-.115"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask3_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask3_1854_5393)">
            <path
                d="M24.216 16.028l.122.014a.316.316 0 01-.1.201.294.294 0 01-.202.072.315.315 0 01-.244-.1.401.401 0 01-.093-.288.51.51 0 01.043-.2.272.272 0 01.115-.137.36.36 0 01.18-.043.301.301 0 01.193.058.28.28 0 01.093.172l-.122.021a.2.2 0 00-.057-.114.158.158 0 00-.108-.036.195.195 0 00-.143.071.323.323 0 00-.065.216.33.33 0 00.058.215.178.178 0 00.143.057.172.172 0 00.122-.043.223.223 0 00.065-.143"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask4_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask4_1854_5393)">
            <path
                d="M24.854 16.186l.014.107a.468.468 0 01-.093.015.215.215 0 01-.1-.022.122.122 0 01-.058-.057.454.454 0 01-.014-.144v-.43h-.086v-.093h.086v-.18l.122-.072v.252h.129v.1h-.13v.43c0 .022.002.044.008.065a.05.05 0 00.021.021.086.086 0 00.043.015.41.41 0 00.058-.007z"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask5_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask5_1854_5393)">
            <path
                d="M25.657 15.927a.316.316 0 00.058.216.18.18 0 00.143.071.172.172 0 00.137-.071c.04-.06.057-.13.05-.201a.345.345 0 00-.058-.216.18.18 0 00-.219-.055.173.173 0 00-.06.048.338.338 0 00-.05.216v-.008zm.388.366V16.2a.23.23 0 01-.201.115.286.286 0 01-.273-.187.524.524 0 01-.007-.394.287.287 0 01.386-.161.244.244 0 01.088.075v-.36h.122v1.005h-.115z"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask6_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask6_1854_5393)">
            <path
                d="M26.59 15.863h.402a.251.251 0 00-.043-.144.186.186 0 00-.15-.071.195.195 0 00-.144.057.23.23 0 00-.072.158m.409.194l.129.021a.308.308 0 01-.115.172.38.38 0 01-.459-.036.388.388 0 01-.093-.28.401.401 0 01.093-.286.323.323 0 01.244-.1.307.307 0 01.244.1c.068.08.101.182.093.287v.028h-.545c.003.066.028.13.072.18a.2.2 0 00.143.071.186.186 0 00.122-.043c.035-.03.06-.07.072-.114z"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask7_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask7_1854_5393)">
            <path
                d="M27.53 15.927a.38.38 0 00.035.187.18.18 0 00.295.029.323.323 0 00.064-.216.33.33 0 00-.057-.215.173.173 0 00-.144-.064.18.18 0 00-.136.071.31.31 0 00-.057.208zm0 .366h-.115V15.29h.122v.359a.244.244 0 01.2-.1c.045 0 .09.009.13.028.038.015.073.04.1.072a.494.494 0 01.079.265.415.415 0 01-.093.294.287.287 0 01-.215.108.229.229 0 01-.208-.108v.086z"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask8_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask8_1854_5393)">
            <path
                d="M28.333 16.3h.15v-.739h-.143l-.007.74zm0-.875h.15v-.143h-.143l-.007.143z"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask9_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask9_1854_5393)">
            <path
                d="M29.058 16.186l.021.107a.467.467 0 01-.093.015.215.215 0 01-.108-.022.122.122 0 01-.05-.057.45.45 0 01-.014-.144v-.43h-.094v-.093h.094v-.18l.122-.072v.252h.122v.1h-.122v.43a.219.219 0 000 .065.05.05 0 00.028.021.086.086 0 00.043.015.406.406 0 00.05-.007z"
                fill="#FEFEFE"
            />
        </g>
        <mask
            height="33"
            id="mask10_1854_5393"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
            width="32"
            x="2"
            y="-4"
        >
            <path d="M2 28.136h32V-4H2.007v32.136H2z" fill="#fff" />
        </mask>
        <g mask="url(#mask10_1854_5393)">
            <path
                d="M15.751 11.666a1.177 1.177 0 00-.272-.731.855.855 0 00-1.248.114 1.22 1.22 0 00-.201.617h1.721zm1.772.84H14.03c.01.225.087.442.222.624a.826.826 0 00.66.301.989.989 0 00.488-.13c.12-.075.224-.172.308-.286l1.722.158c-.22.41-.55.752-.954.982-.502.227-1.05.33-1.6.302a3.265 3.265 0 01-1.427-.258 2.095 2.095 0 01-.861-.811 2.461 2.461 0 01-.337-1.313 2.31 2.31 0 01.681-1.736 2.597 2.597 0 011.894-.66 3.35 3.35 0 011.542.295 2 2 0 01.86.86c.216.46.317.964.295 1.47v.202z"
                fill="#9A1B27"
            />
        </g>
    </svg>
);

export default withIconContainer(IconSepa);
